import speakingurl from 'speakingurl';

export default (name = '', options = {}) => speakingurl(name.normalize('NFD').replace(/[\u0300-\u036F]/g, ''), { custom: { '.': '.' }, separator: '_', maintainCase: true, ...options });
